import { SavedView } from '@sprint/sprint-react-components';
import DataGridRequest from './DataGridRequest';
export class DealSavedViewsRequest extends DataGridRequest<SavedView> {
    Url = '/subscribers/lists/api/deal';
}
